export default __webpack_public_path__ + "static/version-control-5d374a80c5c796e1416c19668220f14b.png";